import {type PressEvent} from '@react-types/shared';
import {Checkbox} from '@wandb/components';
import React from 'react';

import {useRunSelectorFeatureDisabled} from '../RunSelectorFeaturesContext';

type RowSelectionProps = {
  checkboxState: 'unknown' | 'checked' | 'unchecked' | 'partial';
  isCrossProjectRun?: boolean;
  isGroup: boolean;
  isTableCollapsed: boolean;
  onPress?(event: PressEvent): void;
};

export function RowSelection({
  checkboxState,
  isCrossProjectRun = false,
  isGroup,
  isTableCollapsed,
  onPress,
}: RowSelectionProps) {
  const isDisabled = useRunSelectorFeatureDisabled();

  const isCheckboxDisabled =
    isDisabled('tag') && isDisabled('move') && isDisabled('delete');

  if (isCheckboxDisabled || isTableCollapsed) {
    return null;
  }

  return (
    <Checkbox
      aria-label={isGroup ? 'Select group' : 'Select run'}
      data-test="select-run-checkbox"
      isDisabled={isCrossProjectRun}
      isSelected={checkboxState === 'checked'}
      isIndeterminate={checkboxState === 'partial'}
      onPress={onPress}
    />
  );
}
